import React from 'react';
import Loader from 'react-loaders';
import format from 'date-fns/format';
import { Flex, Div } from './hocs/withStyles';

const Loading = props => {
  const { forDestinations, departureDate, returnDate } = props;
  return (
    <Flex p={[0]} direction="column" width="100%">
      <Div width="90%" m="0 auto">
        <Flex
          justifyContent="center"
          css={{
            marginTop: '60px'
          }}
        >
          <Loader.Loader type="ball-scale-multiple" active color="#FFEC65" />
        </Flex>
        <Div
          style={{
            textAlign: 'center',
            marginTop: '70px',
            fontSize: '1.1em'
          }}
        >
          {forDestinations && (
            <Flex
              direction="column"
              width="100%"
              alignItems="center"
              css={{
                fontSize: '1.5em',
                '@media (orientation: portrait)': {
                  fontSize: '1.2em'
                }
              }}
            >
              <Div color="white">Finding sunny trips...</Div>
              <Div color="white" m={[2, 0]} css={{ textAlign: 'center' }}>
                {format(departureDate, 'dddd')}
                <br />
                to
                <br />
                {format(returnDate, 'dddd')}
              </Div>
            </Flex>
          )}
        </Div>
      </Div>
    </Flex>
  );
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading.js